import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-native-builds-security-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './native-builds-security-section.component.html',
  styleUrl: './native-builds-security-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NativeBuildsSecuritySectionComponent {
  protected readonly securityFeatures = [
    {
      icon: '@tui.shield-check',
      title: 'Isolated build machines',
      description:
        'Every build runs in its own isolated environment that is destroyed after completion.',
    },
    {
      icon: '@tui.lock',
      title: 'Encrypted storage',
      description:
        'All certificates, secrets, and environment variables are encrypted at rest and in transit.',
    },
    {
      icon: '@tui.trash-2',
      title: 'No code retention',
      description:
        'We never persist your repository files. Code is cloned fresh for each build and deleted immediately after.',
    },
  ];
}
